import { Dispatch, SetStateAction } from 'react';

interface Props {
  label: React.ReactElement;
  setState: Dispatch<SetStateAction<string>>;
  value: string;
  disabled?: boolean;
}

const StateDropdown = ({ label, setState, value, disabled = false }: Props) => {
  const states = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
  ];

  return (
    <>
      {label}
      <select
        aria-label="state-dropdown"
        disabled={states.length === 0 || disabled}
        className="form-select lazuli-select"
        onChange={(e) => {
          setState(e.target.value);
        }}
        value={value}
      >
        <option value="" hidden={true}>
          Select a State
        </option>
        {states.map((state) => (
          <option value={state} key={state}>
            {state}
          </option>
        ))}
      </select>
    </>
  );
};

export default StateDropdown;
